export default {
  'Submit': 'Enviar',
  'Save': 'Guardar',
  'enterOTP': 'Introduzca el código de verificación',
  'otpSent': 'Código de Verificación Enviado',
  'login/signup': 'Iniciar sesión / Registrarse',
  'resendCode': 'Reenviar codigo',
  'edit': 'Editar',
  'otpMessage': 'Se envió un código de 6 dígitos a su número celular',
  'oyo360WelcomeMessage': 'Iniciar sesión / Registrarse',
  'oyo360ResendCode': 'Reenviar codigo',
  'oyo360Edit': 'Editar',
  'oyo360otpMessage': 'Se envió un código de 6 dígitos a su número celular',
  'buttonActionContinue': 'Continuar',
  'chooseLanguage': 'Elegir un idioma',
  'currentLanguage': 'IDIOMA ACTUAL',
  'otherLanguages': 'OTROS IDIOMAS',
  'google': 'Google',
  'facebook': 'Facebook',
  'or': 'o',
  'buttonActionSubmit': 'Enviar',
  'welcomeTitle': 'Bienvenido a Oyo',
  'welcomeHeadingForMailLogin': 'Ingrese la dirección de correo electrónico asociada a su cuenta de OYO',
  'welcomeHeadingForPhoneLogin': 'Ingrese el número móvil asociado a su cuenta de OYO',
  'emailIdLabel': 'Identificación de correo',
  'phoneNumberLabel': 'Número de teléfono',
  'passwordLabel': 'Contraseña',
  'newPasswordLabel': 'Nueva contraseña',
  'confirmNewPasswordLabel': 'Confirmar nueva contraseña',
  'emailErrorMessage': 'Por favor ingrese el ID de correo electrónico correcto',
  'phoneNumberErrorMessage': 'Por favor ingrese el número de teléfono correcto',
  'passwordErrorMessage': 'Por favor ingrese la contraseña correcta',
  'confirmPasswordErrorMessage': 'La contraseña no coincide',
  'generateNewPassword': 'Generar una nueva contraseña',
  'loginButtonLabel': 'Acceso',
  'loginWithPhoneButtonLabel': 'Continuar con el teléfono',
  'loginWithOtp': 'Inicia sesión con OTP en su lugar',
  'loginWithEmailButtonLabel': 'Continuar con ID de correo electrónico',
  'back': 'atrás',
  'loginWithOtpTitle': 'Introduzca el código de verificación',
  'loginWithOtpHeading': 'Se envió un código de 6 dígitos a su número de teléfono',
  'listYourProperty': 'Enliste su propiedad',
  'privacyPolicy': 'Política de privacidad',
  'verifyEmail': 'Confirme su dirección de correo electrónico',
  'verifyMobile': 'Verificar el número de móvil',
  'forgotPasswordPhoneSubHeading': 'Le enviaremos un código de 6 dígitos para verificar su número de teléfono',
  'forgotPasswordMailSubHeading': 'Le enviaremos un código de 6 dígitos para verificar su ID de correo electrónico',
  'newPasswordCondition1': 'La contraseña debe tener un  número y un símbolo',
  'newPasswordCondition2': 'Debe tener al menos 8 caracteres',
  'newPasswordCondition3': 'Debe tener minúsculas y mayúsculas',
  'confirmLogin': 'Confirmar e iniciar sesión',
  'getOTP': 'Obtener OTP',
  'invalidInput': 'entrada inválida',
  'passwordResetMessage': 'Contraseña generada con éxito',
  'otpErrorMessage': 'Por favor ingrese la OTP correcta',
  'resendOtpSuccessMessage': 'OTP se ha reenviado en su número de móvil con éxito',
  'InternalServerErrorMessage': 'error de servidor interno',
  'resetPasswordHeading': 'Se envió un código de 6 dígitos a su correo electrónico y número de teléfono.',
  'signingIn': 'Iniciando sesión',
  'invalidMobileNumber': 'Numero de celular invalido',
  'privacyFooterText': 'Al iniciar sesión en su cuenta, acepta nuestros {termsOfUse} y {privacyPolicy}',
  'and': 'y',
  'termsOfUse': 'Condiciones de uso',
  'listProperty': 'Enliste su propiedad',
  'whiteSpace': ' ',
  'errorNoAssociatedHotels': 'No tienes Hoteles asociados',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'passwordChangeInformationText': 'Será desconectado de todos los dispositivos después de cambiar su contraseña'
};
